/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BookingInvoiceSummary } from './BookingInvoiceSummary';
import type { BookingTherapist } from './BookingTherapist';
import type { MinimalClientWithoutStatus } from './MinimalClientWithoutStatus';
import type { MinimalDocumentationEntry } from './MinimalDocumentationEntry';
import type { OnlineMeeting } from './OnlineMeeting';
import type { Payment } from './Payment';
export type BookingWithoutEvent = {
    createdAt: string;
    moveRequestedStart: string | null;
    moveRequestedEnd: string | null;
    id: number;
    locationSelection: BookingWithoutEvent.locationSelection;
    isConfirmed: boolean;
    isOutage: boolean;
    outageFeeApplies: BookingWithoutEvent.outageFeeApplies | null;
    price: string;
    outageFeePrice: string | null;
    taxRate: string;
    onlineMeeting: OnlineMeeting | null;
    payment: Payment | null;
    moveRequestedLocation: BookingWithoutEvent.moveRequestedLocation | null;
    moveRequestedMessage: string | null;
    therapistId?: number;
    therapist?: BookingTherapist;
    invoiceSummary?: BookingInvoiceSummary | null;
    isPaymentArchived?: boolean;
    client: MinimalClientWithoutStatus | null;
    documentationEntries: Array<MinimalDocumentationEntry>;
};
export namespace BookingWithoutEvent {
    export enum locationSelection {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
    }
    export enum outageFeeApplies {
        YES = 'yes',
        NO = 'no',
        NOT_SELECTED = 'not-selected',
    }
    export enum moveRequestedLocation {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
    }
}

